export default function transformDeveloperName(name: string): string[] {
  const cleanedName = name.replace(/[.,]/g, ' ').replace(/\s+/g, ' ').trim();
  const [firstName, lastName] = cleanedName.split(' ');
  return [`${firstName} ${lastName}`, `${lastName} ${firstName}`];
}
